<script>
  import Vue from 'vue'
  import Component from './component'
  Vue.component(
    'new-price',
    Component
  )
</script>



// WEBPACK FOOTER //
// index.vue?1078aa3a